'use strict';

/**
 * Component for colors
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../../templates/components/detail/field-colors.hbs');

var ColorComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        customColors: function() {
            return this.getCustomColors();
        },
    },

    getCustomColors: function() {
        var customColors = '';

        var field = this.getOption('field');

        if (field.sourceFields && field.sourceFields.customColors) {
            customColors = this.model.get(field.sourceFields.customColors);
        }

        return customColors;
    },

    getText: function() {
        var field = this.getOption('field');

        return this.model.getTextValue(field.name);
    },

    hasValue: function() {
        return this.getText() ? true : false;
    },
});

module.exports = ColorComponent;